/* Deliver the explicit protection choice before the theme's cart form can submit.
 * Navidium retains fee selection, product properties, and checkout integration.
 */
(() => {
  let pending = false;
  window.addEventListener('pageshow', () => {
    pending = false;
    document.querySelectorAll('#nvd-with-checkout-btn[aria-busy], #nvd-without-checkout-btn[aria-busy]').forEach(button => {
      button.disabled = false;
      button.removeAttribute('aria-busy');
    });
  });
  window.addEventListener('click', async event => {
    const button = event.target.closest?.('#nvd-with-checkout-btn, #nvd-without-checkout-btn');
    const wantsProtection = button?.id === 'nvd-with-checkout-btn';
    if (!button || typeof addProtection !== 'function' ||
        typeof nvdUpdateProtection !== 'function' || typeof removeNavidium !== 'function' || typeof nvdRedirectToCheckout !== 'function') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (pending) return;
    pending = true;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    const existingError = button.parentElement.querySelector('[data-yours-protection-error]');
    existingError?.remove();
    async function getCart() {
      const response = await fetch('/cart.js', { cache: 'no-store', headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Cart could not be checked.');
      return response.json();
    }
    try {
      if (!wantsProtection) {
        const cart = await getCart();
        for (const item of cart.items.filter(item => item.handle === 'navidium-shipping-protection')) {
          await removeNavidium(item.variant_id);
        }
        const confirmed = await getCart();
        if (confirmed.items.some(item => item.handle === 'navidium-shipping-protection')) {
          throw new Error('Protection could not be removed.');
        }
        localStorage.removeItem('cart_protection');
        localStorage.setItem('nvd_opted_out', 'true');
        nvdRedirectToCheckout();
        return;
      }
      const selected = localStorage.getItem('nvdVariant');
      if (!/^\d+$/.test(selected || '')) throw new Error('Protection is still loading.');
      const cart = await getCart();
      const current = cart.items.find(item => item.handle === 'navidium-shipping-protection');
      if (!current) {
        localStorage.removeItem('cart_protection');
        await addProtection(selected);
      } else if (String(current.variant_id) !== selected) {
        await nvdUpdateProtection(current.variant_id, selected);
      }
      const confirmed = await getCart();
      if (!confirmed.items.some(item => item.handle === 'navidium-shipping-protection' &&
          String(item.variant_id) === selected && item.quantity > 0)) {
        throw new Error('Protection was not added.');
      }
      localStorage.setItem('cart_protection', selected);
      nvdRedirectToCheckout();
    } catch (error) {
      const message = document.createElement('p');
      message.dataset.yoursProtectionError = '';
      message.setAttribute('role', 'alert');
      message.textContent = wantsProtection
        ? 'Shipping protection could not be added. Please try again, or choose checkout without protection.'
        : 'Your cart could not be checked. Please reload the page and try again.';
      button.insertAdjacentElement('afterend', message);
      pending = false;
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  }, true);
})();
